import { LOCALES, type Locale } from '@quoter/shared/locale'
import { useI18n } from '../i18n/LocaleContext'
import { cn } from '../lib/cn'

/** EN / PT segmented control. Persists via LocaleProvider. */
export function LanguageSwitch({ className }: { className?: string }) {
  const { t, locale, setLocale } = useI18n()
  return (
    <div
      role="group"
      aria-label={t.language.switch}
      className={cn(
        'inline-flex rounded-full border border-gray-200 bg-surface p-0.5 text-[12px] font-semibold',
        className,
      )}
    >
      {LOCALES.map((code: Locale) => {
        const active = code === locale
        return (
          <button
            key={code}
            type="button"
            aria-pressed={active}
            lang={code}
            onClick={() => setLocale(code)}
            className={cn(
              'rounded-full px-3 py-1 uppercase tracking-wide transition-colors',
              active ? 'bg-gray-900 text-gray-50' : 'text-gray-600 hover:text-gray-900',
            )}
          >
            {code}
          </button>
        )
      })}
    </div>
  )
}
